/**
 * OnboardingSuccess.tsx
 * Final screen shown after successfully completing the onboarding flow.
 * Shows intro video and "Start Chatting" button to dismiss.
 */
import React from "react";
import { View, ScrollView, StyleSheet } from "react-native";
import CustomButton from "../../common/general/CustomButton/CustomButton";
import CustomText from "../../common/general/CustomText/CustomText";
import { CompanionVideoPlayer } from "../shared/CompanionVideoPlayer";
import { colors, spacing, spacingStyles } from "../../../styles/design-system";

export interface OnboardingSuccessProps {
  onComplete: () => void;
}

function OnboardingSuccess({ onComplete }: OnboardingSuccessProps) {

  return (
    <ScrollView style={styles.container} showsVerticalScrollIndicator={false}>
      <View style={[spacingStyles.pLg]}>
        {/* Header */}
        <View style={styles.header}>
          <CustomText
            text="companion_onboarding_success_title"
            size="xl"
            weight="bold"
            style={[{ color: colors.grey[900], marginBottom: spacing.xs }]}
          />
          <CustomText
            text="companion_onboarding_success_video_hint"
            size="m"
            style={[{ color: colors.grey[600] }]}
          />
        </View>

        {/* Video Player */}
        <CompanionVideoPlayer />

        {/* Benefits List */}
        <View style={styles.benefitsSection}>
          <View style={styles.benefitItem}>
            <CustomText text="companion_onboarding_intro_benefit_1" size="m" weight="semibold" style={undefined} />
            <CustomText
              text="companion_onboarding_intro_benefit_1_subtitle"
              size="s"
              style={{ color: colors.grey[600] }}
            />
          </View>

          <View style={styles.benefitItem}>
            <CustomText text="companion_onboarding_intro_benefit_2" size="m" weight="semibold" style={undefined} />
            <CustomText
              text="companion_onboarding_intro_benefit_2_subtitle"
              size="s"
              style={{ color: colors.grey[600] }}
            />
          </View>

          <View style={styles.benefitItem}>
            <CustomText text="companion_onboarding_intro_benefit_3" size="m" weight="semibold" style={undefined} />
            <CustomText
              text="companion_onboarding_intro_benefit_3_subtitle"
              size="s"
              style={{ color: colors.grey[600] }}
            />
          </View>

          <View style={styles.benefitItem}>
            <CustomText text="companion_onboarding_intro_benefit_4" size="m" weight="semibold" style={undefined} />
            <CustomText
              text="companion_onboarding_intro_benefit_4_subtitle"
              size="s"
              style={{ color: colors.grey[600] }}
            />
          </View>
        </View>

        {/* Start Button */}
        <View style={styles.buttonContainer}>
          <CustomButton
            text="buttons.companion_onboarding_success_cta"
            onPress={onComplete}
            styleType="primary"
            style={{ width: "100%" }}
          />
        </View>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  header: {
    alignItems: "center",
    marginBottom: spacing.sm,
  },
  benefitsSection: {
    marginBottom: spacing.sm,
  },
  benefitItem: {
    marginBottom: spacing.xs,
  },
  buttonContainer: {
    marginTop: spacing.sm,
  },
});

export default OnboardingSuccess;
